export default __webpack_public_path__ + "static/media/LightspeedPNG.5a120eee.png";